import React, { Component } from 'react';
import { connect } from "react-redux";
import { newLoanStepperService, metadataService, workflowService, userService, ServiceUtil, SessionService } from "../_services";
import { history } from "../_helpers";
import { SlPageTitle, SlButton, SlRadioButton, SlBranchDisplay, SlBusyIndicator, SlImgYesNo, SlFormEntryRow, SLImageSelectable,SLSvgElectronicDelivery,SLSvgInStorePickup, SlSectionTitle,SLCardSelectable } from './editors';
import PropTypes from 'prop-types';
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    CardText,
    CardFooter,
    Row,
    Col
} from "reactstrap";
import { newLoanActions, registrationActions, refinanceIncreaseLoanActions } from "../_actions";
import { workflowConstants, } from '../_constants';
import Stepper from "./subcomponents/Stepper";
import { FindOffice } from "./subcomponents";
import qs from "query-string";
import { InstantFunding } from './subcomponents/InstantFunding';
import { RePaySaleResponseModel } from '../_models';


class FundingSelection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEdit: false,
            isRefinance: false,
            isInvalid: true,
            isBankingValid: false,
            fundSelection: "",
            branchId: null,
            sunLoanOffice: {},
            loadSelectedOffice: false,
            fundDelivery: null,
            accountNumber: null,
            routingNumber: null, 
            steps: [],
            currentStep: '',
            changeLoanRequest: JSON.parse(sessionStorage.getItem("changeLoanRequest")),
            isInstantFundingEnabled: false,
            instantFundingPaymentStatus : null,
            instantFundingPaymentData : null, 
            isBusy : false,
            hideInstantFunding : true,
        }
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleBankingInfoChange = this.handleBankingInfoChange.bind(this);
        this.handleOnRePayMessage = this.handleOnRePayMessage.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    async componentDidMount() {
        try {
            this.setState({isBusy : true})
            const {hideInstantFunding }= this.state;
            let isEdit = false;
            let isRefinance = false;
            let personalInfoState = null;
            const personalInfo = SessionService.getPersonalInfo();
            if (personalInfo) {
                personalInfoState = personalInfo.state;
            }
            if(hideInstantFunding === false){
                const [isInstantFunding] = await Promise.all([userService.isInstantFundingEnabled(personalInfoState)]);
        
                if (isInstantFunding === true) {
                    this.setState({
                        isInstantFundingEnabled: isInstantFunding,
                        fundDelivery: metadataService.fundDeliveryType.Electronic,
                        fundSelection: "eDelivery"
                    });
                } else {
                    this.setState({
                        isInstantFundingEnabled: isInstantFunding,
                        fundDelivery: metadataService.fundDeliveryType.InStore,
                        fundSelection: "inStore"
                    });
                }
            }else{
                this.setState({
                    isInstantFundingEnabled: false,
                    fundDelivery: metadataService.fundDeliveryType.InStore,
                    fundSelection: "inStore"
                });
            }
    
            // check for query param indicating user navigated here by edit pencil
            if (this.props.location.search) {
                let query = qs.parse(this.props.location.search);
                if (query.edit) {
                    isEdit = query.edit;
                }
                if (query.refi) {
                    isRefinance = query.refi;
                }
                let fundingInformation = SessionService.getFundingInformation();
                if (fundingInformation) {
                    this.setState({ loadSelectedOffice: true });
                    await metadataService.getBranch(fundingInformation.BranchId).then(response => {
                        if (response.status < 1) {
                            let sunLoanOffice = response.data;
                            this.setState({ sunLoanOffice });
                        }
                    });
                    this.setState({ loadSelectedOffice: false })
                }
                let changeLoanRequest = JSON.parse(sessionStorage.getItem("changeLoanRequest"));
                let workflowData = workflowService.getCurrentWorkflowStepData();
                if (workflowData) {
                    this.setState({
                        steps: newLoanStepperService(workflowData.workflowId),
                        currentStep: workflowData.currentStepperStep,
                        changeLoanRequest,
                        isEdit,
                        isRefinance
                    });
                } else {
                    history.push("/LogInMain");
                }
            }
        } catch (error) {
            
        } finally {
            this.setState({isBusy : false})
        }
       
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevState) !== JSON.stringify(this.state)) {
            this.validateForSubmit();
        }
    }

    handleRadioChange(newValue) {
        let { fundDelivery, branchId, accountNumber, routingNumber, isBankingValid } = this.state;
        if (newValue.target.value === "eDelivery") {
            accountNumber = null;
            routingNumber = null;
            isBankingValid = false;
            fundDelivery = metadataService.fundDeliveryType.Electronic;
            branchId = null;
        }
        else {
            branchId = null;
            fundDelivery = metadataService.fundDeliveryType.InStore;
        }

        this.setState({
            accountNumber: accountNumber,
            routingNumber: routingNumber,
            isBankingValid: isBankingValid,
            fundSelection: newValue.target.value,
            fundDelivery: fundDelivery,
            branchId: branchId
        });
    }

    handleCheckChange(e) {
        const { target } = e;
        const { name } = target

        this.setState({
            [name]: !this.state[name]
        });
    }

    handleLocationChange(office) {
        this.setState({ branchId: office.sunLoanBranchId, sunLoanOffice: office });

    }

    handleBankingInfoChange(bankingInfo) {
        this.setState({
            accountNumber: bankingInfo.accountNumber,
            routingNumber: bankingInfo.routingNumber,
            isBankingValid: bankingInfo.isSubComponentValid
        });
    }

    validateForSubmit() {
        let isValid = false;

        if (this.state.fundSelection === "eDelivery") {
            /*isValid = this.state.isBankingValid;*/
            isValid = this.state.instantFundingPaymentStatus === "PAYMENT_SUCCESS";
        }
        else if (this.state.fundSelection === "inStore") {
            isValid = (this.state.branchId !== null);
        }

        this.setState({ isInvalid: !isValid });
    }
    handleOnRePayMessage(args){
        if(typeof args === "string"){
            this.setState({instantFundingPaymentStatus : args })       
        }else{
            this.setState({instantFundingPaymentData : new RePaySaleResponseModel(args) })                   
        }
    }
    handleSubmit() {

        const { dispatch } = this.props;

        let workflowData = workflowService.getCurrentWorkflowStepData();

        let fundingInfo = {
            BranchId: this.state.branchId ? this.state.branchId : 0,
            FundDelivery: this.state.fundDelivery,
            BankAccountNumber: 0,
            BankRoutingNumber: 0,
            Email: this.props.email,
            sunLoanOffice: this.state.sunLoanOffice

        };
        if (this.state.fundSelection === "eDelivery") {          
            fundingInfo.instantFundingPaymentStatus = this.state.instantFundingPaymentStatus;
            fundingInfo.InstantFunding = this.state.instantFundingPaymentData;
        }        
        if (this.state.isEdit) {
            SessionService.setFundingInformation(fundingInfo);
            if (this.state.isRefinance) {
                history.push("/Refinance/Summary");
            } else {
                history.push("/ConfirmationSummary");
            }
        } else {
            if (workflowData.workflowId === workflowConstants.NEW_LOAN_WORKFLOW) {
                dispatch(newLoanActions.handleFundingRequest(fundingInfo));
            }
            else if (workflowData.workflowId === workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW) {
                dispatch(newLoanActions.handleFundingRequest(fundingInfo));
            }
            else if (workflowData.workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW) {
                sessionStorage.setItem("leadId", this.props.leadId);
                sessionStorage.setItem("email", this.props.email);
                dispatch(newLoanActions.handleFundingRequest(fundingInfo));
            }
            else if (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW) {
                dispatch(refinanceIncreaseLoanActions.handleFundingRequest(fundingInfo));          
            }
        }
    }


    goBack() {
        // needs to a return to previous step request for all workflows, not just organic
        const { dispatch } = this.props;
        dispatch(registrationActions.handleFinancialInformationBackRequest());
    }

    render() {
        let workflowData = workflowService.getCurrentWorkflowStepData();
        const {isBusy} = this.state;
        return (
            <div>
                <Stepper stepData={this.props.steps} currentStep={this.props.currentStep} />
                {!this.state.hideInstantFunding && <SlPageTitle pageName={"Funding"} />}
                <SlBusyIndicator visible={isBusy} />
                {!isBusy && <div>
                    {!this.state.hideInstantFunding &&  <Row className={"justify-content-center mt-3 pt-3"}>
                    <Col className="mr-3 justify-content-center text-center d-flex" xs={12} sm={6} md={3}>
                        <SLImageSelectable
                            title={this.state.isInstantFundingEnabled === false ? metadataService.getLabel("ElectronicDeliveryComingSoon") : metadataService.getLabel("ElectronicDelivery")}
                            name={"FundDelivery"}
                            value={"eDelivery"}
                            selected={this.state.fundSelection === "eDelivery"}                                               
                            image ={<SLSvgElectronicDelivery selected={this.state.fundSelection === "eDelivery"} />}
                            onChange={this.handleRadioChange}
                            disabled={this.state.isInstantFundingEnabled === false}
                            />
                    </Col> 
                    <Col className="mr-3 justify-content-center text-center d-flex" xs={12} sm={6} md={3}>
                    <SLImageSelectable
                            title={metadataService.getLabel("InStorePickup")}
                            name={"FundDelivery"}
                            value={"inStore"}
                            selected={this.state.fundSelection === "inStore"}                                                
                            image ={<SLSvgInStorePickup selected={this.state.fundSelection === "inStore"} />}
                            onChange={this.handleRadioChange}
                        />
                    </Col>
                    </Row>}
                    <Card>
                        <CardBody>
                            <Row className={"no-gutters justify-center"}>
                                <Col>
                                <Card>
                                    <CardBody>
                                        <div name={"ofc"} className={"no-gutters"}>
                                            {/*{this.state.loadSelectedOffice && <SlBusyIndicator visible={this.state.loadSelectedOffice} />}*/}
                                            {!this.state.fundSelection && this.state.fundSelection !== "" && Object.keys(this.state.sunLoanOffice).length > 0 &&
                                                <Col sm='12' md={{ offset: 3, size: 6 }}>
                                                    <p>{metadataService.getLabel("CurrentSelectedBranch")}</p>
                                                    <SLCardSelectable 
                                                        name="CurrentSelectedBranch"
                                                        value={this.state.sunLoanOffice.sunLoanBranchId}
                                                        selected={true}                                                 
                                                        cardBody={<SlBranchDisplay sunLoanBranch={
                                                            {
                                                                address1 : this.state.sunLoanOffice.address1,
                                                                address2 : this.state.sunLoanOffice.address2,
                                                                city : this.state.sunLoanOffice.city,
                                                                state : this.state.sunLoanOffice.state,
                                                                postalCode : this.state.sunLoanOffice.postalCode,
                                                                phone : this.state.sunLoanOffice.phone,
                                                                sunLoanBranchId : this.state.sunLoanOffice.sunLoanBranchId
                                                            }
                                                        }/>}
                                                        title={<div className="mb-0 pb-0 mt-0 mb-0">
                                                            <small className="mb-0 pb-0 mt-0 mb-0">{this.state.sunLoanOffice.branchName}</small>
                                                            <p  className="mb-0 pb-0 mt-0 mb-0">{this.state.sunLoanOffice.city}</p>
                                                        </div>}
                                                    />
                                                    {/* <SlBranchDisplay sunLoanBranch={this.state.sunLoanOffice} /> */}
                                                </Col>
                                            }
                                            {this.state.fundSelection === "inStore" && (
                                                <FindOffice hideNext={true} handleSelectedOffice={this.handleLocationChange} selectedBranch={this.state.sunLoanOffice} />
                                            )}
                                            {this.state.fundSelection === "eDelivery" && (                                           
                                                <Col className="BankingInfo">             
                                                    <p className="alert alert-warning instant-funding-message col-xs">
                                                        {metadataService.getMessage("InstantFunding")}
                                                    </p>
                                                    <InstantFunding
                                                        onRePayMessage={this.handleOnRePayMessage}                                                    
                                                    />                                             
                                                </Col>
                                            )}
                                        </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                            <div>
                                {this.state.isEdit ?
                                    <div className="text-center">
                                        <SlButton name={"Save"}
                                            size={"lg"}
                                            onClick={this.handleSubmit}
                                            disabled={this.state.isInvalid} />
                                    </div>
                                    :
                                    <Row   className={"text-center"}>
                                        <Col md={{ size: 12 }} sm={12}>
                                        <span className='p-2'>
                                            <SlButton
                                                name={"Back"}
                                                size={"lg"}
                                                onClick={this.goBack}
                                                cssClass="backBtn"
                                            />
                                            </span>
                                            <span  className='p-2'>
                                            <SlButton
                                                name={"Next"}
                                                size={"lg"}
                                                onClick={this.handleSubmit}
                                                disabled={this.state.isInvalid}
                                            />
                                            </span>
                                        </Col>
                                        <Col md={{ size: 4 }} sm={12}>
                                        </Col>
                                    </Row>
                                }
                            </div>
                            <div className="text-center mt-3">
                                <span className="small-Text">{metadataService.getMessage("ChooseLoanOfficeDisclaimer")}</span>
                            </div>
                        </CardBody>
                    </Card>
                </div>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;

    const { completedSteps, leadId, email } = state.registration;
    const { steps, currentStep } = state.users;

    return {
        loggedIn, completedSteps, leadId, email, steps, currentStep
    };
}

FundingSelection.propTypes = {
    onNext: PropTypes.func
}

const connectedFundingSelection = connect(mapStateToProps)(FundingSelection);

export { connectedFundingSelection as FundingSelection };